define('cartware_checkout/components/coupon',[
	"jquery",
	"cartware/components/_base",
	"gigaset/spinner",
	"bootstrap-button"
], function(
	$,
	Component,
	Spinner
) {
	return Component.create({
		$init: function() {
			var self = this;

			$(document).on("submit", "#discount-coupon-form", function(e) {
				var form = $(e.target);

				e.preventDefault();
				e.stopPropagation();

				Spinner.add();

				self.submit(form);
			});

			$(document).on("click", "#discount-coupon-form button", function(e) {
				var button = $(e.target),
					action = button.data("action"),
					form = button.parents("#discount-coupon-form");

				self.submit(form, action);
			});
		},

		submit: function(form, action) {
			var wrap = form.parents("#cartware-checkout-coupon-wrap:first"),
				vForm = new VarienForm(form.get(0)),
				couponCode = form.find("[name=\"coupon_code\"]:first"),
				removeInput = form.find("[name=\"remove\"]:first"),
				messageContainer = wrap.find(".message:first"),
				loadingMessage = messageContainer.find(".loading:first");

			switch (action) {
				case "cancel":
					couponCode.removeClass("required-entry");
					removeInput.val(1);
					break;

				case "apply":
				default:
					couponCode.addClass("required-entry");
					removeInput.val(0);
					break;
			}

			if (vForm.validator.validate()) {
				wrap
					.find("button")
					.attr("disabled", "disabled")
					.animate({
						opacity: 0.4
					});

				loadingMessage.detach();
				messageContainer.empty();
				loadingMessage.appendTo(messageContainer);
				loadingMessage.css("display", "block");

				try { window.accordion._layout(); } catch (e) {}

				Spinner.add();

				$.ajax(form.attr("action"), {
					method: "POST",
					data: form.serialize(),
					dataType: "json"
				}).then(function(res) {
					if ("message" in res) {
						alert(res.message);
					}

					$.each(res.blocks, function(blockName, blockHtml) {
						switch (blockName) {
							case "checkout.onepage.review.coupon":
								$("#cartware-checkout-coupon-wrap").replaceWith(blockHtml);
								break;

							case "review_info":
								$("#checkout-review-wrapper").replaceWith(blockHtml);
								break;
						}

						try { window.accordion._layout(); } catch (e) {}
					});

					Spinner.remove();
				});
			}

			try { window.accordion._layout(); } catch (e) {}
		}
	});
});
